module.exports = __webpack_public_path__ + "img/p-38.4b1078c9.jpg";